/**
 * Route: /teacher/classes/:classId/sessions/:sessionId
 * Live-session dashboard — 6 tabs: content, materials, attendance, review, assignments, GV note.
 * Child of /teacher layout (role='teacher' guard already applied by parent route.tsx).
 * This file uses flat dot-notation to avoid nesting under $classId's Outlet and its
 * beforeLoad redirect guard (which only allows roster/attendance/grades/assignments tabs).
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { LiveSessionDashboard } from '@client/components/teacher/live-session/live-session-dashboard';
import { authClient } from '@client/lib/auth-client';

export const Route = createFileRoute(
  '/teacher/classes/$classId/sessions/$sessionId',
)({
  beforeLoad: async ({ navigate }) => {
    const { data: session } = await authClient.getSession();
    if (!session?.user) {
      throw navigate({ to: '/login', search: { redirect: '/teacher' }, replace: true });
    }
    const role = (session.user as { role?: string }).role ?? '';
    if (role !== 'teacher') {
      throw navigate({ to: '/403', replace: true });
    }
    return { session };
  },
  component: SessionDashboardPage,
});

function SessionDashboardPage() {
  const { classId, sessionId } = Route.useParams();
  const navigate = useNavigate();

  if (!classId || !sessionId) {
    void navigate({ to: '/teacher', replace: true });
    return null;
  }

  return <LiveSessionDashboard classId={classId} sessionId={sessionId} />;
}
